/**
 * **One armed thing on the board** (`decisions/0189` point 5). The board's layer-3 members — the aim,
 * a Draw tool, the terrain rail's brush or tool, the Measure tool, the Inspect tool — each own the left button while armed, so arming
 * one disarms the rest. The transition is pure: `CombatApp` feeds it the armed flags before and
 * after a render and disarms what it returns. A gesture (hold-M measure) is not an armed thing.
 */

/** The layer-3 members, as one armed flag each. */
export const ARMED_KINDS = ["aim", "draw", "terrain", "measure", "inspect"] as const;
export type ArmedKind = (typeof ARMED_KINDS)[number];
export type BoardArmed = Record<ArmedKind, boolean>;

/** The members to disarm after `prev` → `next`: when a member newly armed, every other one still armed. */
export function disarmOnArm(prev: BoardArmed, next: BoardArmed): ArmedKind[] {
  const armedNow = ARMED_KINDS.filter((k) => next[k] && !prev[k]);
  if (armedNow.length === 0) return [];
  return ARMED_KINDS.filter((k) => next[k] && !armedNow.includes(k));
}
